/*
  OLIVES & GRACE | og-enhance.js (September 2026)
  Small, progressive improvements on top of the existing sections.
  Nothing here replaces the configurator logic in sections/og-main-product.liquid:
  it only opens it, labels the choices better and adds information around it.
  Settings and texts come from snippets/og-enhance.liquid (window.OGEnhance).
*/
(function () {
  'use strict';

  var C = window.OGEnhance || {};
  var T = C.t || {};
  document.documentElement.classList.add('og-enh-js');

  /* ---------- helpers ---------- */

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function formatMoney(cents) {
    var format = C.moneyFormat || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) { return '0'; }
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    if (text) { node.textContent = text; }
    return node;
  }

  /* ---------- product page ---------- */

  function enhanceProduct(section) {
    if (section.dataset.ogEnh === 'done') { return; }
    section.dataset.ogEnh = 'done';

    var variants = [];
    try {
      var data = section.parentNode.querySelector('[data-og-variants="' + section.dataset.sectionId + '"]') ||
        document.querySelector('[data-og-variants="' + section.dataset.sectionId + '"]');
      variants = JSON.parse(data.textContent);
    } catch (e) { variants = []; }

    var options = Array.prototype.slice.call(section.querySelectorAll('[data-og-option]'));

    function optionName(option) {
      var name = option.dataset.optionName;
      if (!name) {
        var legend = option.querySelector('legend');
        name = legend ? legend.textContent : '';
      }
      return (name || '').toLowerCase();
    }

    function selectedValues() {
      return options.map(function (option) {
        var checked = option.querySelector('[data-og-option-radio]:checked');
        return checked ? checked.value : null;
      });
    }

    /* 1. Frame swatches */
    options.forEach(function (option) {
      if (optionName(option).indexOf('frame') === -1) { return; }
      each(option.querySelectorAll('.og-product__values label'), function (label) {
        if (label.querySelector('.og-enh-sw')) { return; }
        var v = (label.dataset.value || '').toLowerCase();
        var key = v.indexOf('unframed') > -1 || v.indexOf('zonder') > -1 ? 'unframed'
          : v.indexOf('black') > -1 || v.indexOf('zwart') > -1 ? 'black'
          : v.indexOf('natural') > -1 || v.indexOf('naturel') > -1 ? 'natural'
          : v.indexOf('white') > -1 || v.indexOf('wit') > -1 ? 'white'
          : v.indexOf('espresso') > -1 ? 'espresso' : '';
        if (!key) { return; }
        label.insertBefore(el('i', 'og-enh-sw og-enh-sw--' + key), label.firstChild);
      });
    });

    /* 2. Edition thumbnails, taken from the variant images */
    options.forEach(function (option, index) {
      var name = optionName(option);
      if (!/edition|colou?r|colorway/.test(name)) { return; }
      var values = option.querySelector('.og-product__values');
      if (!values) { return; }
      var added = 0;
      each(values.querySelectorAll('label'), function (label) {
        if (label.querySelector('.og-enh-thumb')) { return; }
        var match = variants.find(function (v) {
          return v.options[index] === label.dataset.value && v.featured_image && v.featured_image.src;
        });
        if (!match) { return; }
        var src = match.featured_image.src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var img = el('img', 'og-enh-thumb');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 44;
        img.height = 44;
        label.insertBefore(img, label.firstChild);
        added += 1;
      });
      if (added) { values.classList.add('og-enh-thumbs'); }
    });

    /* 3. Verse text inside the verse buttons, plus a link to the verse collection */
    var verseOption = null;
    var verseIndex = -1;
    options.forEach(function (option, index) {
      if (optionName(option).indexOf('verse') > -1 || optionName(option).indexOf('vers') === 0) {
        verseOption = option;
        verseIndex = index;
      }
    });

    var verses = C.verses || {};
    var verseLink = null;

    if (verseOption) {
      var verseValues = verseOption.querySelector('.og-product__values');
      var anyText = false;
      each(verseOption.querySelectorAll('.og-product__values label'), function (label) {
        if (label.querySelector('.og-enh-vtext')) { return; }
        var value = (label.dataset.value || '').trim();
        var info = verses[value.toLowerCase()];
        var ref = el('span', 'og-enh-vref', label.textContent.trim());
        var text = null;
        if (info) {
          text = el('span', 'og-enh-vtext', '“' + info.text + '”');
        } else if (value.toLowerCase() === 'custom' || value.toLowerCase() === 'eigen vers') {
          ref.textContent = T.customTitle || value;
          text = el('span', 'og-enh-vtext', T.customText || '');
        }
        if (!text) { return; }
        label.textContent = '';
        label.appendChild(ref);
        label.appendChild(text);
        anyText = true;
      });
      if (anyText && verseValues) {
        verseValues.classList.add('og-enh-verses');
      }

      /* the summary panel gets the chosen verse written out */
      var summaryRows = section.querySelector('.og-product__summary-rows');
      if (summaryRows && !section.querySelector('.og-enh-summary-verse')) {
        var summaryVerse = el('p', 'og-enh-summary-verse');
        summaryRows.parentNode.insertBefore(summaryVerse, summaryRows.nextSibling);
        verseLink = el('a', 'og-enh-verse-link');
        verseLink.hidden = true;
        summaryVerse.parentNode.insertBefore(verseLink, summaryVerse.nextSibling);
      }
    }

    function updateVerseSummary(values) {
      var summaryVerse = section.querySelector('.og-enh-summary-verse');
      if (!summaryVerse || verseIndex < 0) { return; }
      var value = values[verseIndex];
      var info = value ? verses[value.toLowerCase()] : null;
      summaryVerse.textContent = info ? '“' + info.text + '”' : '';
      if (verseLink) {
        if (info && info.handle) {
          verseLink.href = (C.collectionsUrl || '/collections') + '/' + info.handle;
          verseLink.textContent = (T.verseLink || 'Every work with this verse') + ' →';
          verseLink.hidden = false;
        } else {
          verseLink.hidden = true;
        }
      }
    }

    /* 4. Price inside each size button */
    var sizeOption = null;
    var sizeIndex = -1;
    options.forEach(function (option, index) {
      var name = optionName(option);
      if (name.indexOf('size') > -1 || name.indexOf('formaat') > -1 || name.indexOf('maat') > -1) {
        sizeOption = option;
        sizeIndex = index;
      }
    });

    function updateSizePrices(values) {
      if (!sizeOption || !variants.length) { return; }
      var box = sizeOption.querySelector('.og-product__values');
      if (box) { box.classList.add('og-enh-sizes'); }
      each(sizeOption.querySelectorAll('.og-product__values label'), function (label) {
        var value = label.dataset.value;
        var matching = variants.filter(function (v) {
          if (v.options[sizeIndex] !== value) { return false; }
          return values.every(function (sel, i) {
            return i === sizeIndex || !sel || v.options[i] === sel;
          });
        });
        var available = matching.filter(function (v) { return v.available; });
        var pool = available.length ? available : matching;
        var span = label.querySelector('.og-enh-price');
        if (!pool.length) {
          if (span) { span.textContent = ''; }
          return;
        }
        var min = Math.min.apply(null, pool.map(function (v) { return v.price; }));
        var max = Math.max.apply(null, pool.map(function (v) { return v.price; }));
        if (!span) {
          span = el('span', 'og-enh-price');
          label.appendChild(span);
        }
        span.textContent = (min !== max ? (T.from || 'from') + ' ' : '') + formatMoney(min);
      });
    }

    /* 5. Shipping line and help links under the add to cart button */
    var purchase = section.querySelector('[data-og-purchase]');
    if (purchase && !section.querySelector('.og-enh-ship') && T.shipping) {
      var ship = el('p', 'og-enh-ship', T.shipping);
      var help = el('p', 'og-enh-help');
      var a1 = el('a', '', T.shippingLink || 'Shipping & returns');
      a1.href = C.shippingUrl || '/pages/shipping-returns';
      var q = el('span', '', (T.questions || 'Questions?') + ' ');
      var mail = el('a', '', 'info@olivesandgrace.co');
      mail.href = 'mailto:info@olivesandgrace.co';
      q.appendChild(mail);
      help.appendChild(a1);
      help.appendChild(q);
      var error = purchase.querySelector('[data-og-error]');
      purchase.insertBefore(help, error ? error.nextSibling : null);
      purchase.insertBefore(ship, help);
    }

    /* 6. Reassurance list: specific promises instead of "secure checkout" */
    var reassurance = section.querySelector('.og-product__reassurance');
    if (reassurance && T.trust1) {
      each(reassurance.querySelectorAll('li'), function (li) {
        if (/secure|veilig/i.test(li.textContent)) { li.textContent = T.trust1; }
      });
    }

    /* keep everything in sync with the configurator */
    function refresh() {
      var values = selectedValues();
      updateSizePrices(values);
      updateVerseSummary(values);
    }
    section.addEventListener('change', function (event) {
      if (event.target.matches('[data-og-option-radio]')) {
        setTimeout(refresh, 0);
      }
    });
    refresh();

    /* keep the configurator in view when it moves to the next step (the panels change height) */
    var wizard = section.querySelector('[data-og-wizard]');
    function keepInView() {
      setTimeout(function () {
        if (!wizard || wizard.hidden) { return; }
        var top = wizard.getBoundingClientRect().top;
        if (top < 60) {
          window.scrollTo({ top: window.pageYOffset + top - 120, behavior: 'smooth' });
        }
      }, 460);
    }
    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-og-next], [data-og-back], [data-og-edit]')) { keepInView(); }
    });
    section.addEventListener('change', function (event) {
      if (event.target.matches('[data-og-option-radio]')) { keepInView(); }
    });

    /* 7. Open the configurator straight away */
    var launch = section.querySelector('[data-og-launch]');
    if (launch && !launch.hidden) {
      launch.click();
    }

    /* 8. Options with a single choice are chosen automatically */
    setTimeout(function () {
      options.forEach(function (option) {
        var radios = option.querySelectorAll('[data-og-option-radio]');
        if (radios.length === 1 && !radios[0].checked) {
          radios[0].checked = true;
          radios[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }, launch ? 320 : 0);
  }

  /* ---------- collection pages: price filter values and the availability filter ---------- */

  function enhanceCollection() {
    var commaFormat = /comma_separator/.test(C.moneyFormat || '');
    each(document.querySelectorAll('input[name$="price.gte"], input[name$="price.lte"]'), function (input) {
      if (!commaFormat || input.dataset.ogEnhFixed) { return; }
      input.dataset.ogEnhFixed = 'true';
      ['value', 'placeholder'].forEach(function (attr) {
        var raw = input.getAttribute(attr);
        if (raw && /^\d+$/.test(raw) && raw.length > 2) {
          var fixed = String(Math.round(parseInt(raw, 10) / 100));
          if (attr === 'value') { input.value = fixed; }
          input.setAttribute(attr, fixed);
        }
      });
    });
    /* everything is made to order, so "in stock / out of stock" says nothing */
    each(document.querySelectorAll('input[name="filter.v.availability"]'), function (input) {
      var group = input.closest('.og-collection__filter-group, details, [data-filter-group], fieldset');
      if (group && !group.querySelector('input[name$="price.gte"]')) { group.hidden = true; group.style.display = 'none'; }
    });
  }

  /* ---------- cart: write out the chosen verse under the reference ---------- */

  function enhanceCart() {
    var verses = C.verses || {};
    each(document.querySelectorAll('.og-cart__meta > div'), function (row) {
      var dt = row.querySelector('dt');
      var dd = row.querySelector('dd');
      if (!dt || !dd || row.nextElementSibling && row.nextElementSibling.classList.contains('og-enh-cart-verse')) { return; }
      if (!/vers/i.test(dt.textContent)) { return; }
      var info = verses[dd.textContent.trim().toLowerCase()];
      if (!info) { return; }
      var line = el('div', 'og-enh-cart-verse', '“' + info.text + '”');
      row.parentNode.insertBefore(line, row.nextSibling);
    });
  }

  /* ---------- product page: load the Pairs & Sets section ----------
     The section file sections/og-pairs-sets.liquid is rendered by Shopify on request and
     placed above the related products. If the section is added to the product template in
     the theme editor (with its own settings), that copy is used and nothing is loaded here. */

  function loadPairsSets() {
    if (document.querySelector('[data-og-ps]') || !document.querySelector('[data-og-product]')) { return; }
    var url = window.location.pathname + '?section_id=og-pairs-sets';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || html.indexOf('data-og-ps') === -1) { return; }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var section = holder.firstElementChild;
        if (!section) { return; }
        var anchor = document.querySelector('.og-rp-section, [data-og-rp]');
        if (anchor) {
          var target = anchor.closest('.shopify-section') || anchor;
          target.parentNode.insertBefore(section, target);
        } else {
          var main = document.getElementById('MainContent') || document.body;
          main.appendChild(section);
        }
        /* scripts inserted with innerHTML do not run, so they are recreated */
        each(section.querySelectorAll('script'), function (old) {
          var fresh = document.createElement('script');
          if (old.type) { fresh.type = old.type; }
          each(old.attributes, function (a) { if (a.name !== 'type') { fresh.setAttribute(a.name, a.value); } });
          fresh.textContent = old.textContent;
          old.parentNode.replaceChild(fresh, old);
        });
      })
      .catch(function () {});
  }

  /* ---------- start ---------- */

  function start() {
    each(document.querySelectorAll('[data-og-product]'), enhanceProduct);
    if (C.page === 'product') { loadPairsSets(); }
    if (C.page === 'collection' || C.page === 'search') { enhanceCollection(); }
    if (C.page === 'cart') { enhanceCart(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* collection filters are re-rendered after filtering */
  document.addEventListener('og:collection:updated', enhanceCollection);
  if ((C.page === 'collection' || C.page === 'cart') && 'MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(C.page === 'cart' ? enhanceCart : enhanceCollection, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
